/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { LargeFeedFilter } from "cms/shared/feeds/large";
import { FeedbackHelpful } from "@simplicitycms/simplicity-forms";
import { useSimpliCity } from "cms/hooks/use-simplicity";
import { FeatureFlagGuard } from "../cms/features/feature-flag-guard";

const News = () => {

    const { webpage, model } = useSimpliCity();

    const type = "model.news";

    return (
        <main>
            <h1 style={{ marginTop: "16px" }}>News</h1>

            <LargeFeedFilter
                type={type}
                enableBar={true}
            />

            <FeatureFlagGuard feature="feature_was_helpful" >
                <FeedbackHelpful model={model} webpage={webpage} />
            </FeatureFlagGuard>

        </main>
    );
};

export { News };
